import React from "react";
import { Link } from 'react-router';
import angleLeftWhiteIcon from '../../../assets/images/angle-left-white.svg';

import { whereToShopMenu, servicesMenu, offersMenu, helpCenterMenu, legalMenu } from '../constants'

const SecondaryMenu = (accountNumber, firstName) => {
  const renderMenuDropdown = (label, menu, isHelpCenter) => {
    return <li className="dropdown secondary-nav-link">
    <div className="dropdown-toggle" data-toggle="dropdown">
      {label}<span className="margin-left-10"><img className="rotate-icon" alt="icon" src={angleLeftWhiteIcon}/></span>
    </div>
    <ul className="dropdown-menu secondary-nav-links-wrapper">
    {
      menu.map(({title, url, external, id}) => (
        !external ?
          <li className="list-item">
            <Link id={id} to={url}>{title}</Link>
          </li> :
          <li className="list-item">
            <a id={id} target="_blank" href={url}>{title}</a>
          </li>
      ))
    }
    { isHelpCenter && 
        <li li className="secondary-dropdown">
          <div style={{ fontSize: 16,padding: '0px 20px', color: '#fff'}}>
            Legal<span className="margin-left-10 rotate-icon"><img alt="icon" className="rotate-icon-sub" src={angleLeftWhiteIcon}/></span>
          </div>
          <ul className="secondary-dropdown-menu">
          {
            legalMenu.map(({title, url, external, id}) => (
              !external ?
                <li className="list-item">
                  <Link id={id} to={url}>{title}</Link>
                </li> :
                <li className="list-item">
                  <a id={id} target="_blank" href={url}>{title}</a>
                </li>
            ))
          }
          </ul>
        </li>
    }
    </ul>
  </li>
  }

  return (
    <div className="secondary-nav">
      <ul className="secondary-nav-links">
        {renderMenuDropdown('Where to shop', whereToShopMenu)}
        {renderMenuDropdown('Services', servicesMenu)}
        {renderMenuDropdown('Offers', offersMenu(accountNumber, firstName))}
        {renderMenuDropdown('Help Center', helpCenterMenu, true)}
      </ul>
    </div>
  )
}

export default SecondaryMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/SecondaryMenu.js
 **/